import React from 'react';

import EditOrganization from 'screens/organizations/components/EditOrganization';
import EditOrganizationProvider from 'screens/organizations/context/EditOrganizationProvider';

const EditOrganizationScreen = () => <EditOrganization />;

export default EditOrganizationScreen;

EditOrganizationScreen.getLayout = (page) => (
  <EditOrganizationProvider>{page}</EditOrganizationProvider>
);
